export default __webpack_public_path__ + "static/HZH_GVR_watching-0dc164d292632a36d0af79d8f3c1b29d.png";